export default __webpack_public_path__ + "static/media/kaapi-2.be890f0e.jpg";